// @flow

import { combineReducers } from 'redux';

import layout from './layout';
import organization from './organization';
import contact from '../Contact/modules';

export default (combineReducers({
  layout,
  organization,
  contact,
}): any);
